<template>
  <div class="i-feed">
    <div class="up">
      <!-- 我的地址 -->
      <div class="facab">
        <div class="oText">{{ $t('main.feedback') }}</div>
      </div>
    </div>
    <div class="down">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item :label="$t('main.title')">
          <el-input @keyup.enter.native="submmit" v-model="form.name" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.suggestionsDetail')">
          <el-input v-model="form.content" type="textarea" :rows="4" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('main.telephoneAccount')">
          <el-input @keyup.enter.native="submmit" v-model="form.phone" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
        <el-form-item class="is-required" :label="$t('main.email')">
          <el-input @keyup.enter.native="submmit" v-model="form.email" :placeholder="$t('main.pleaseEnter')"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center; margin-top: 60px;">
        <el-button class="btn" type="danger" @click="submmit">{{ $t('main.commit') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { guestbook } from "@/api/index";
import Cookies from "js-cookie";
export default {
  data () {
    return {
      form: {
        content_id: 0,
        product_id: 0,
        real_name: "",
        content: "",
        phone: "",
        email: "",
        site_id: 1
      }
    };
  }, methods: {
    submmit () {
      //TODO  问题，当前没有标题字段
      var params = this.form;
      this.form.site_id = this.$store.state.site_id;
      // this.form.content_id=0;//意见建议 这个id暂时取不到
      // this.form.product_id = 0;//这个id暂时也取不到
      this.form.real_name = JSON.parse(Cookies.get('userinfo')).username;
      var paramsto = {
        "req": params
      }
      guestbook(paramsto).then((res) => {
        if (res.rsp.code === 0) {
          this.$message({
            message: this.$t('main.operationCompletedSuccessfully'),
            type: 'success'
          });
          window.location.reload();
        } else {
          this.$message({
            message: res.rsp.msg,
            type: 'error'
          })
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.i-feed {
  min-height: 46.25rem;
  background: #fafafa;
  border: 1px solid #e5e5e5;

  .up {
    width: 100%;
    height: 4.375rem;
    background: #f2f2f2;
    border-bottom: 1px solid #e5e5e5;
    line-height: 4.375rem;

    .oText {
      color: #1a1a1a;
      margin-left: 1.5rem;
      cursor: pointer;
    }

    .tEndAdd {
      padding-right: 2.5rem;
    }
  }

  .down {
    padding: 3.75rem 5.625rem;

    .btn {
      width: 12.5rem;
      background: #635796;
      border-radius: 4px;
      border-color: #635796;
      color: #ffffff;
    }
  }
}
</style>
